
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { Tag } from "@/script/apps/cms/entity/CmsEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { TagService } from "@/script/apps/cms/service/TagService";
import { ElMessage } from "element-plus";
import { DictService } from "@/script/apps/system/service/DictService";
import { Dict } from "@/script/apps/system/entity/SystemEntity";

@Options({})
export default class TagDetail extends BaseDetail {
  private service = new TagService();
  private attributes: Dict[] = [];

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_cms_tag",
      "/cms/tag",
      "/cms/tag",
      this.service
    );
    data.typesName = "tag-type";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
    type: [{ required: true, message: "请选择类型", trigger: "change" }],
  };

  public newEntity() {
    const entity: Tag = {};
    return entity;
  }

  protected initOptions() {
    super.initOptions();
    
    const dictService = new DictService();
    dictService.loadChildItems("tag-attribute", (data: any) => {
      this.attributes = data;
    });    
  }
}
